<section
  class="result-container"
  [ngClass]="{ complete: quizSessionScore.is_passed, failed: !quizSessionScore.is_passed }"
>
  <header>
    @if (lessonGroup$ | async; as lessonType) {
      <span class="section-name">{{ lessonType?.name }}</span>
    }
    @if (!isExam) {
      @if (quizSessionScore.is_passed) {
        <h2>{{ 'exercises.exercise_complete' | transloco }}</h2>
      }
      @if (!quizSessionScore.is_passed) {
        <h2>{{ 'exercises.exercise_failed' | transloco }}</h2>
      }
    }
    @if (isExam) {
      @if (quizSessionScore.is_passed) {
        <h2>{{ 'exercises.exam_complete' | transloco }}</h2>
      }
      @if (!quizSessionScore.is_passed) {
        <h2>{{ 'exercises.exam_failed' | transloco }}</h2>
      }
    }
  </header>
  <div class="score-summary">
    @if (quizSessionScore.score / quizSessionScore.total === 1) {
      <p>{{ 'exercises.perfect' | transloco }}</p>
    }
    @if (quizSessionScore.score / quizSessionScore.total !== 1 && quizSessionScore.is_passed) {
      <p>
        {{
          'exercises.congratulation'
            | transloco: { percent: quizSessionScore.valid / (quizSessionScore.total_unique || 1) | percent }
        }}
      </p>
    }
    @if (!quizSessionScore.is_passed) {
      <p>
        {{
          'exercises.oh_no_start_again'
            | transloco: { percent: quizSessionScore.valid / (quizSessionScore.total_unique || 1) | percent }
        }}
      </p>
    }

    <div class="svg-container">
      @if (!quizSessionScore.is_passed) {
        <span inlineSVG="/icons/icon_sad_face.svg"></span>
      } @else {
        @if (isExam) {
          <span inlineSVG="/icons/icon_cup.svg"></span>
        }
        @if (!isExam) {
          <span inlineSVG="/icons/icon_medal.svg"></span>
        }
      }
    </div>
    <span inlineSVG="/icons/"></span>
  </div>
</section>
